import type { ApolloError } from "@apollo/client";

const forbiddenSubstring = function (message: string | undefined): boolean {
  if (!message) return false;
  const lower = message.toLowerCase();
  return lower.includes("not authorized") || lower.includes("forbidden");
};

/**
 * True when a GraphQL/network error indicates the viewer is not allowed to access the resource.
 * Matches server messages such as "Not authorized" from Absinthe resolvers.
 */
export const graphqlErrorIndicatesForbidden = function (error: ApolloError | undefined): boolean {
  if (!error) return false;
  if (forbiddenSubstring(error.message)) return true;
  return Boolean(error.graphQLErrors?.some((e) => forbiddenSubstring(e.message)));
};
